import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AppState } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../common/global-variables';
import { Observable, Subject, Subscription } from 'rxjs';

import { HttpUtils } from '../../../common/http/http-utils';
import { State } from '@clr/angular';
var $ = require('jquery');

import { JobsNotifierService } from '../../services/job-notifier.service';
import { RefreshSharedService } from '../../refresh-shared-service';
import { formatDateTimeCustom } from '../../../common/utils/utils';
import { HttpClient, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/map'

@Component({
  selector: 'activity-log',
  host: {'[class.content-container]': 'true'},
  styles: [require('./activity-log.scss')],
  encapsulation: ViewEncapsulation.None,
  template: require('./activity-log.html')
})

export default class ActivityLog {
  @Input() services: string;
  @Input() isActivityLogVisible: boolean = false;
  @Input() filters: string;
  @Input() pageSize: number = 10;

  private url: string = '/hybridity/api/jobsForActivityLog?';
  private pageNumber: number = 1;
  private rsService: RefreshSharedService;
  private refreshSubscription: Subscription;
  private currentClassName: string = '';

  private filtersList = [
    {
      name: 'activityLog.username',
      value: 'username'
    },
    {
      name: 'activityLog.operationType',
      value: 'operationType'
    },
    {
      name: 'activityLog.entityName',
      value: 'entityName'
    }
  ];
  private selectedFilter;
  private filterValue;

  private sortField;
  private sortOrder;

  private subscription: Subscription;
  private refreshActivityLogSubscription: Subscription;
  private jobs = [];
  private totalJobs: number = 0;
  private value: string = '';
  private loading: boolean = true;

  constructor(public appState: AppState,
              public translate: TranslateService,
              public http: HttpClient,
              public jobNotifierService: JobsNotifierService,
              private rss: RefreshSharedService) {
    translate.use(GlobalVariables.LOCALE);
      this.rsService = rss;
      this.currentClassName = 'ActivityLog';
  }

  ngOnChanges() {
    if (this.isActivityLogVisible) {
        this.rsService.setParam({
          loadedComponent: this.currentClassName,
          detailPageIDName: '',
          shouldReloadInventoryTree: false
        });
    }
  }

  ngOnInit() {
    this.refreshSubscription = this.rsService.getRefreshParam()
    .subscribe (
      item => {
        this.handleEmittedValues(item);
    });
    this.getActivityLogs();
  }

  handleEmittedValues(item) {
    if (item.loadedComponent === this.currentClassName) {
        this.subscribeForJobs(this.getUrl());
    }
  }

  getActivityLogs() {
    this.refreshActivityLogSubscription = this.jobNotifierService.getRefreshActivityLogEvent()
    .subscribe(() => {
          this.subscribeForJobs(this.getUrl());
    },
    error => {},
    () => {}
    );
  }

  search() {
    if (this.selectedFilter && this.selectedFilter !== '') {
      this.subscribeForJobs(this.getUrl());
    }
  }

  refresh(state: State) {
    if (state.sort) {
      this.sortField = state.sort.by;
      this.sortOrder = (state.sort.reverse) ? -1 : 1;
    }
    this.pageNumber = ((state.page.from) / this.pageSize) + 1;
    this.subscribeForJobs(this.getUrl());
  }

  getUrl() {
    let url = this.url;
    if (this.services && $.trim(this.services) !== '') {
      url += 'jobType=' + this.services + '&';
    }
    if (this.filters && this.filters !== '') {
      url += this.filters + '&';
    }
    if (this.filterValue && this.filterValue !== '') {
      url += this.selectedFilter + '=' + this.filterValue + '&';
    }
    if (this.sortField && this.sortField !== '') {
      url += 'sortField=' + this.sortField + '&';
    }
    if (this.sortOrder && this.sortOrder !== null) {
      url += 'sortOrder=' + this.sortOrder + '&';
    }
    if (this.pageSize) {
      url += 'pageSize=' + this.pageSize + '&';
    }
    if (this.pageNumber) {
      url += 'pageNumber=' + this.pageNumber;
    } else {
      url += 'pageNumber=1';
    }
    return url;
  }

  pollJobs(url) {
    return this.http.get(HttpUtils.getBaseUrl() + url).map(
      res => res
    );
  }

  subscribeForJobs(url) {
    this.loading = true;
    this.subscription = this.pollJobs(url).subscribe(res => {
            this.filterJobs(res);
        },
        error => this.onPollFailure(),
        () => {}
    );
  }

  onPollFailure() {
  }

  filterJobs(res) {
    if (res && res.data && res.data.activityLogs) {
      this.jobs = res.data.activityLogs;
      this.totalJobs = res.data.activityLogs.length;
    } else {
      this.jobs = [];
      this.totalJobs = 0;
    }
    this.loading = false;
  }

  ngOnDestroy() {
    if (this.subscription) {
        this.subscription.unsubscribe();
    }
    if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
    }
    this.rsService.resetParam();
    if ( this.refreshActivityLogSubscription ) this.refreshActivityLogSubscription.unsubscribe();
  }

  formatDateTime(timeStamp) {
    return formatDateTimeCustom(timeStamp);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/activity-log/activity-log.component.ts